export const CHECK_EMAIL_API = "/api/Auth/check-email";
export const LOGIN_USER_API = "/api/Auth/login";
export const DOOR_INSPECTION_API = "/api/Report/DownloadPropertyInspectionPDF";
export const GET_CLINET_ID_API = "/api/MasterData/GetClientUserRoleMapping";
export const PROPERTY_DASHBOARD_API =
  "/api/GetInspectionData/summary-by-clientId?";
export const GET_PROPERTY_INFO_WITH_MASTER =
  "/api/Inspection/GetInspectionMasterData/";
export const GENERATEQRCODE_API = "/api/QrCode?text=";
export const SAVE_SURVEY_FORM_DATA = "/api/Inspection/inspection/save";
export const UPLOAD_IMAGE_API = "/api/Inspection/upload";
export const DELETE_IMAGE_API = "/api/Inspection/delete-blob-url?blobUrl=";
export const GET_INSPECTION_PROPERTY_INFO_BYID =
  "/api/Inspection/GetInspectionPropertyInfoById/";
export const CREATE_INSPECTION_PROPERTY_APPROVAL_HISTORY =
  "/api/Inspection/CreateInspectionPropertyApprovalHistory";
export const GET_PROPERTY_USER_MAPPING =
  "/api/Inspection/GetPropertyUserMapping/";
export const GET_NEXT_REF_NUMBER = "/api/Inspection/GetNextRefNumber/";
export const UPDATE_PROPERTY_USER_MAPPING_STATUS =
  "/api/Inspection/UpdateStatusOfPropertyUserMapping/";
export const GET_PROPERTY_COMPLIANCE_SUMMARY =
  "/api/GetInspectionData/GetPropertyComplianceSummary";
export const GET_DOOR_INSPECTION_DATA =
  "/api/GetInspectionData/GetFullInspectionByDoorRef?doorRef=";
export const UPDATE_PROPERTY_IMAGE =
  "/api/GetInspectionData/UpdatePropertyImage";
export const GET_FLOORPLAN_IMAGE =
  "/api/GetInspectionData/GetFLoorPlanByFloorNo?";
export const GET_SURVEY_BOOKINGS =
  "/api/SurveyBooking/get-bookings-by-user?email=";
export const CLIENT_ONBOARD_API = "/api/Client/onboard-client";
export const SENT_OTP_TO_CHECK_CLIENT = "/api/Client/check-client";
export const VALIDATE_OTP_NEW_CLIENT = "/api/Client/validate-otp";
export const USERS_BY_CLIENT = "/api/Client/GetUsersByClient?";

export const GET_PROPERTIES_CLIENT =
  "/api/Client/GetRolesandPropertiesList-Client";
export const ADD_BLOCK_BY_CLIENT_ID = "/api/Property/AddBlock-Client";
export const GET_BLOCK_BY_CLIENT_ID = "/api/Property/GetBlocks-Client";
export const ADD_PROPERTY_BY_CLIENT_ID = "/api/Property/AddProperty-Client";
export const UPDATE_PROPERTY_BY_CLIENT_ID =
  "/api/Property/UpdateProperty-Client";
export const DELETE_PROPERTY_BY_MASTER_ID="/api/Property/DeleteProperty";  
export const GET_ALL_PROPERTY_BY_CLIENT_ID =
  "/api/Property/GetAllProperty-Client";

export const APPROVER_REQUEST_FOR_CHANGE = "/api/Inspection/RequestForChange";
export const APPROVER_APPROVE_INSPECTION =
  "/api/Inspection/UpdateDoorApprovalStatus";
export const GET_APPROVER_COMMENTS =
  "/api/Inspection/GetAllRequestForChangeByProperty?inspectedDoorId=";
export const SEND_INSPECTOR_NOTIFICATION_APPROVAL =
  "/api/Inspection/notify-inspector-door-change";
export const SEND_NEXT_INSPECTION_DUEDATE = "/api/Inspection/update-inspection-due-date";
export const GET_ALL_PROPERTY_AND_ROLE_BASED_ON_CLIENT_ID =
  "/api/Client/GetRolesandPropertiesList-Client";
export const INVITE_MEMEBER_AND_ASSIGN_PROPERTY =
  "/api/Client/InviteMemberandAssignProperties";
export const INVITE_MEMEBER_AND_ASSIGN_PROPERTY_V2 ="/api/Client/AssignRoleToOnboardedUser";  
export const DELETE_USER_CLIENT = "/api/Client/DeleteUsersRoleByClient";
export const PAYMENT_CREATE_SESSION="/api/Payment/create-session";
export const GET_CITY_BY_API= "/api/MasterData/GetCity";
export const POST_PROPERTY_FLOOR_IAMGE ="/api/Property/UploadPropertyFloorPlan-Property";
export const GET_USERS_ROLE_BY_CLIENT_ID="/api/Client/GetUsersByClient";
export const POST_PROPERTY_COMPLIANCE_DOCS = "/api/Property/UploadPropertyComplianceDoc-Property"
export const GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT = "/api/Property/GetPropertyFloorDetailsByPropertyId-Client";
export const DELETE_COMPLIANCE_DOC = "/api/Property/DeleteComplianceDocs-Property";
// export const DELETE_FLOOR_PLAN_IMAGE = "/api/Property/DeletePropertyFloorPlan";
export const DELETE_FLOOR_PLAN_IMAGE ="/api/Property/DeleteBlockFloorPlans-Property"
export const UPLOAD_PROPERTY_UPDATE_IMAGE = "/api/Property/UploadPropertyImage";
export const UPLOAD_CLIENT_UPLOADCLIENTBRANDING = "/api/Client/UploadClientBranding";
export const CHECK_SUBDOMAIN_NAME = "/api/Client/CheckSubDomainName";
export const LOGOUT_USER_API = "/api/Auth/logout";

//new inspection assignment
export const GET_ALL_INSPECTION_MASTER = "/api/InspectionMaster/GetAllInspectionMasterByClientId";
export const UPSERT_NEW_INSPECTION = "/api/InspectionMaster/UpsertInspectionMaster";
export const GET_PROPERTIES_AND_INSPECTORS_BY_CLIENT = "/api/InspectionMaster/GetAllPropertiesAndInspectorsByClient";
export const DELETE_PROPERTY_INSPECTION = "/api/InspectionMaster/DeleteInspectionMaster";
export const GET_INSPECTOR_AVAILABLE_SLOTS = "/api/InspectionMaster/GetAvailableSlotsForInspectionAssignment";
export const SCHEDULE_INSPECTION = "/api/InspectionMaster/assign-inspectors";
export const GET_SCHEDULED_DATA = "/api/InspectionMaster/GetInspectionBookedDetails";
export const GET_RESCHEDULED_SLOTS = "/api/InspectionMaster/RescheduleBooking";
export const RE_SCHEDULE_INSPECTION = "/api/InspectionMaster/UpdateRescheduledBooking";

//Lead dashboard
export const GET_RMS_USER_CONTACT_COUNT ="/api/RMS/GetRMSUserContactCount";
export const TRIGGER_EMAIL_TO_RESIDENT_USERS ="/api/RMS/TriggerEmailtoResidentUsers";
export const GET_RMS_USER_INFO_LIST ="/api/RMS/GetRMSUserInfoListWithPostedDetails";
export const DOWNLOAD_RESIDENT_NOTIFICATION_LETTER ="/api/Report/DownloadResidentNotificationLetter";
export const CREATE_RMS_POST_DETAILS ="/api/RMS/CreateRMSPostDetails";
export const TRIGGER_EMAIL_TO_SEND_BOOKING_LINK ="/api/RMS/TriggerEmailtoSendBookingLink";

//subscription add points
export const ADD_SUBSCRIPTION_POINTS = "/api/Payment/AddClientPoints";

//Admin Dashboard
export const GET_INSPECTION_DATA_SUMMARY_BY_CLIENT_ID = "/api/GetInspectionData/summary-by-clientId?clientId=";

//Booking History
export const BOOKING_HISTORY = "/api/Inspection/get-property-inspection-audit-trail";

//Audit Rail
export const GET_DOOR_INSPECTION_AUDIT_TRAIL = "/api/Inspection/get-door-inspection-audit-trail";

//Validate Client form subdomain name
export const VALIDATE_CLIENT_SUBDOMAIN = "/api/Client/ValidateClient";

//Give the Client list associated with the email
export const GET_USER_CLIENT = "/api/Auth/GetUserClients";

//client branding details
export const GET_CLIENT_BRANDING_DETAILS = "/api/Client/Edit-Client";
export const UPDATE_CLIENT_BRANDING_DETAILS = "/api/Client/UploadClientBranding";
export const CHECK_SUBDOMAIN_NAME_NoTOKEN = "api/Client/CheckSubDomainName";

//QR code
export const  GENERATE_QR = "/api/QrCode/GenerateQRCodes";
export const  DOWNLOAD_QR = "/api/QrCode/DownloadQRCodes";
export const LINK_QR_CODES = "/api/QrCode/linkQRcode";

//AI process for action items
export const GET_AI_SUGGESTION = "/api/Inspection/ai-process";
export const SEND_FEEDBACK_TO_AI = "/api/Inspection/ai-suggestion-acceptance";

//contract inspector acceptance
export const CONTRACT_INSPECTOR_ACCEPTANCE = "/api/InspectionMaster/ContractInspectorAcceptance";

//client profile
export const GET_CLIENT_COMPANY_DETAILS = "/api/Client/GetClientCompanyInformations";
export const UPDATE_CLIENT_COMPANY_DETAILS = "/api/Client/UpdateClientCompanyInformations";
export const SAVE_CLIENT_COMPANY_DETAILS = "/api/Client/AddClientCompanyInformations";
export const DELETE_CLIENT_COMPANY_DETAILS = "/api/Client/DeleteClientCompanyInformations";

// User Profile 
export const GET_USER_PROFILEDETAILS = "/api/Client/GetUserProfileDetails";
export const UPDATE_USER_PROFILE_DETAILS = "/api/Client/UpdateUserProfile";
export const UPDATE_MARKETING_PREFERENCES = "/api/Client/SetUserMarketingPrefrences";

// Calendar 
export const INSPECTOR_CALENDERI_VIEW = "/api/InspectionMaster/GetInspectorSlotDetailsByBooking";
//  Action 
export const GET_ACTION_DETAILS = "/api/ActionItems/ActionItems/search";
export const UPDATE_ACTION_ITEMS = "/api/ActionItems/update-actionItem";
export const GET_PROPERTIES_LIST = "/api/Property/GetPropertyList";

//SITE CRUD
export const CREATE_BLOCKS = "/api/Property/CreateBlocksBatch-Property";
export const GET_BLOCK_DATA = "/api/Property/GetBlocks-Property";
export const DELETE_BLOCK_DOCUMENT = "/api/Property/DeleteBlockDocuments-Property";
export const UPDATE_BLOCKS_DATA = "/api/Property/UpdateBlocksBatch-Property";
export const CHECK_COMPANY_CLIENTNAME = "/api/Client/CheckCompanyClientName";
// Download Excel file
export const DOWNLOAD_EXCEL_FILE = "/api/ActionItems/export-action-items-to-excel";
// Mapping selcect cilent
export const SELECT_CLIENT = "/api/Client/GetCompanyClientMappings";

// Mapping selcect cilent
// export const MANUAL_FOLLOW_UP = "/client/{subdomain}/manual-follow-up";


export const BOOKING_MANAGEMENT_AUDIT_HIS = "/api/RMS/GetBookingManagementAuditTrailHistory";
export const RMS_LINK = "/api/Property/GenerateRMSPropertyUrl";

//bookings report
export const GET_BOOKINGS_REPORT = "/api/Property/GetPropertyBookingsReport";
export const GET_RMS_PROPERTIES_AND_CLIENT_COMPANIES_LIST = "/api/Property/GetRMSPropertiesAndClientCompaniesList";

export const GET_EXCLE_REPORT = "/api/Property/ExportPropertyBookingsReportExcel";

export const GET_PROPERTY_INSPECTION_HISTORY = "/api/Property/GetPropertyInspectionHistories";